import { success, notFound } from '../util/Response';
import { createError } from './createError';

/**
 * Turns an Apollo query result into the Response that resolveCurrentScreen maps
 * onto an HTTP status code: success -> 200, notFound -> 404, serverError and
 * networkError -> 500.
 *
 * Apollo Client 4 removed `errors` from the query result in favour of a single
 * `error`. Reading the old field here would have been silent and expensive:
 * `errors` is always undefined under v4, so every API failure would have fallen
 * through to notFound and returned 404 instead of 500.
 *
 * Note that under errorPolicy 'all' -- which createClient sets -- Apollo does
 * not throw for GraphQL or HTTP errors; they arrive on the result. The
 * `.catch(createError(...))` in each screen's fetchData now only catches
 * genuinely thrown errors, which is why the classification lives in createError
 * and is shared by both paths.
 */
export default (hasData, dataBeingFetched = 'data') =>
    apolloQueryResult => {
        if (hasData(apolloQueryResult.data)) {
            return success(apolloQueryResult.data);
        }

        if (apolloQueryResult.error) {
            return createError({ dataBeingFetched })(apolloQueryResult.error);
        }

        return notFound;
    };
